import {
  CHIP_MINIMIZER_MOUNT_TYPES,
  MOUNT_TYPE_FEATURE,
} from '~/core/constants';
import { isSinkLaborProduct, isSinkProduct } from '~/core/helpers';
import { ApplianceModel, DrawingShape } from '~/core/models';

/**
 *  Checks whether the appliance has chip minimizer option.
 * @returns true if is customer supplied sink or a  browsed sink with mount type: undermount or apron front
 */
export const hasChipMinimizer = (appliance: ApplianceModel): boolean => {
  if (isSinkLaborProduct(appliance) || isSinkProduct(appliance)) {
    const features = appliance.features;

    return features.some(
      (feature) =>
        feature.name === MOUNT_TYPE_FEATURE &&
        CHIP_MINIMIZER_MOUNT_TYPES.some((value) => feature.value.match(value))
    );
  } else {
    return false;
  }
};

/**
 * Get the number of chipminimizers in the drawingArea */
export const numberOfChipMinimizerFromDrawingShapes = (
  drawingShapes: DrawingShape[] = []
): number =>
  drawingShapes.reduce((acc, next) => {
    const appliances = next.appliances;
    const appliancesWithChipMinimizer = appliances.filter(
      (appliance) => !!appliance.hasChipMinimizer
    );

    return acc + appliancesWithChipMinimizer.length;
  }, 0);
